import type Highcharts from "highcharts";

/**
 * Runs `append` after the existing `chart.events.render` (if any). Preserves other
 * `chart.events` keys. `render` must stay a `function` so Highcharts binds `this`.
 */
export function nestChartRenderEvent(
  options: Highcharts.Options,
  append: (this: Highcharts.Chart, event: Event) => void,
): Highcharts.Options {
  const prev = options.chart?.events?.render;
  return {
    ...options,
    chart: {
      ...options.chart,
      events: {
        ...options.chart?.events,
        render: function (this: Highcharts.Chart, event: Event) {
          prev?.call(this, event);
          append.call(this, event);
        },
      },
    },
  };
}
